<template>
  <div v-if="justView" class="mt-2">
    <!-- more than 3 answers are displayed in two column -->
    <div v-if="choices.length < 4" class="multiple-question-area">
      <div
        :style="{
          color: textColor || '#000000',
        }"
      >
        <span class="text-addquestion">{{ questionText }}</span>
      </div>
      <div class="chips-area">
        <div class="chip" v-for="(choice, i) in choices" :key="i">
          <span
            :style="{
              color: textColor || '#000000',
            }"
          >
            {{ choice }}
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        class="multiple-question-area"
        :style="{
          color: textColor || '#000000',
        }"
      >
        {{ questionText }}
      </div>
      <div class="col-md-12">
        <div class="row">
          <div
            class="col chip-multiple"
            v-for="(choice, i) in choices"
            :key="i"
          >
            <span
              :style="{
                color: textColor || '#000000',
              }"
            >
              {{ choice }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <p
      v-if="hasComment"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>
    <hr />
  </div>
  <div v-else class="break-word">
    <div v-if="addQuestionTemplate === 'default'">
      <b-form-group
        v-if="type === 'radio'"
        :label="questionText"
        :style="{
          color: textColor || '#000000',
        }"
      >
        <b-form-radio
          v-for="(choice, i) in choices"
          :key="i"
          :name="`radio-multiple-${index}`"
          :value="
            lang === 'br'
              ? choice.text
              : lang === 'us'
              ? choice.textEN
              : choice.textES
          "
          :id="`radio-${index}-${i}`"
          @input="update()"
          v-model="isSelected"
        >
          <template v-if="lang === 'br'">
            <span
              :style="{
                color: textColor || '#000000',
              }"
              >{{ choice.text }}</span
            >
          </template>
          <template v-if="lang === 'us'">
            <span
              :style="{
                color: textColor || '#000000',
              }"
              >{{ choice.textEN }}</span
            >
          </template>
          <template v-if="lang === 'es'">
            <span
              :style="{
                color: textColor || '#000000',
              }"
              >{{ choice.textES }}</span
            >
          </template>
        </b-form-radio>
        <b-textarea
          v-show="
            choices.filter((item) => item.isOther && (lang === 'us' ? item.textEN : lang === 'es' ? item.textES : item.text ) === isSelected)
              .length
          "
          id="textarea"
          v-model="otherComment"
          rows="3"
          max-rows="6"
        ></b-textarea>
      </b-form-group>
      <b-form-group
        v-else-if="type === 'checkbox'"
        :label="questionText"
        :style="{
          color: textColor || '#000000',
        }"
      >
        <b-form-checkbox-group
          class="col-lg-7 col-sm-12"
          button-variant="light"
          buttons
          size="lg"
          stacked
          :id="`check-${index}`"
          :name="`checkbox-multiple-${index}`"
          @input="update()"
          v-model="isSelected"
        >
          <b-form-checkbox
            class="custom-checkbox"
            v-for="(choice, i) in choices"
            :key="i"
            :value="
              lang === 'br'
                ? choice.text
                : lang === 'us'
                ? choice.textEN
                : choice.textES
            "
            :style="`background: ${pageBackground}`"
            :disabled="choice.disabled"
          >
            <div class="row">
              <div class="col-10">
                <template v-if="lang === 'br'">
                  <span
                    style="font-size: 1rem"
                    :style="{
                      color: textColor || '#000000',
                    }"
                    >{{ choice.text }}</span
                  >
                </template>

                <template v-if="lang === 'us'">
                  <span
                    style="font-size: 1rem"
                    :style="{
                      color: textColor || '#000000',
                    }"
                    >{{ choice.textEN }}</span
                  >
                </template>

                <template v-if="lang === 'es'">
                  <span
                    style="font-size: 1rem"
                    :style="{
                      color: textColor || '#000000',
                    }"
                    >{{ choice.textES }}</span
                  >
                </template>
              </div>
              <div class="col-2 text-right">
                <span class="icon-checked-big">
                  <i style="color: #07b2f0" class="fas fa-check"></i>
                </span>
              </div>
            </div>
          </b-form-checkbox>
          <b-textarea
            v-show="
              choices.filter(
                (item) =>
                  item.isOther &&
                  isSelected &&
                  isSelected.indexOf( (lang === 'us' ? item.textEN : lang === 'es' ? item.textES : item.text ) ) != -1,
              ).length
            "
            id="textarea"
            v-model="otherComment"
            rows="3"
            max-rows="6"
          ></b-textarea>
        </b-form-checkbox-group>
      </b-form-group>
    </div>
    <div
      style="display: flex; align-items: center; justify-content: center"
      v-else
    >
      <b-form-group
        :style="{
          color: textColor || '#000000',
        }"
        v-if="type === 'radio'"
        :label="questionText"
        style="min-width: 55%"
      >
        <b-form-radio
          v-for="(choice, i) in choices"
          :key="i"
          :name="`radio-multiple-${index}`"
          :value="choice.text"
          :id="`radio-${index}-${i}`"
          @input="update()"
          v-model="isSelected"
        >
          <span
            v-if="lang === 'br'"
            :style="{
              color: textColor || '#000000',
            }"
            >{{ choice.text }}</span
          >

          <span
            v-if="lang === 'us'"
            :style="{
              color: textColor || '#000000',
            }"
            >{{ choice.textEN }}</span
          >

          <span
            v-if="lang === 'es'"
            :style="{
              color: textColor || '#000000',
            }"
            >{{ choice.textES }}</span
          >
        </b-form-radio>
        <b-textarea
          v-show="
            choices.filter((item) => item.isOther && (lang === 'us' ? item.textEN : lang === 'es' ? item.textES : item.text ) === isSelected)
              .length
          "
          id="textarea"
          v-model="otherComment"
          rows="3"
          max-rows="6"
        ></b-textarea>
      </b-form-group>
      <b-form-group
        :style="{
          color: textColor || '#000000',
        }"
        v-else-if="type === 'checkbox'"
        :label="questionText"
        style="min-width: 55%"
      >
        <b-form-checkbox-group
          class="col-12"
          stacked
          :id="`check-${index}`"
          button-variant="light"
          buttons
          size="lg"
          :name="`checkbox-multiple-${index}`"
          @input="update(index)"
          v-model="isSelected"
        >
          <b-form-checkbox
            class="custom-checkbox"
            v-for="(choice, i) in choices"
            :key="i"
            :value="choice.text"
            :style="`background: ${pageBackground}`"
            :disabled="choice.disabled"
          >
            <div class="row">
              <div class="col-10">
                <span
                  style="font-size: 1rem"
                  :style="{
                    color: textColor || '#000000',
                  }"
                  >{{ choice.text }}
                </span>
              </div>
              <div class="col-2 text-right">
                <span class="icon-checked">
                  <i style="color: #07b2f0" class="fas fa-check"></i>
                </span>
              </div>
            </div>
          </b-form-checkbox>
          <b-textarea
            v-show="
              choices.filter(
                (item) =>
                  item.isOther &&
                  isSelected &&
                  isSelected.indexOf( (lang === 'us' ? item.textEN : lang === 'es' ? item.textES : item.text ) ) != -1,
              ).length
            "
            id="textarea"
            v-model="otherComment"
            rows="3"
            max-rows="6"
          ></b-textarea>
        </b-form-checkbox-group>
      </b-form-group>
    </div>
    <comment-area
      :template="addQuestionTemplate"
      v-if="commentEnabled"
      v-model="comment"
    />
    <hr />
  </div>
</template>
<script>
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  name: 'MultipleChoices',
  components: {
    commentArea,
    applicable,
  },
  props: {
    textColor: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
    questionText: {
      type: String,
      required: true,
    },
    choices: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
    },
    justView: {
      type: Boolean,
    },
    selected: {
      required: false,
    },
    commentEnabled: {
      type: Boolean,
      default: false,
    },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: {
      type: String,
      default: null,
    },
    addQuestionTemplate: { type: String, default: 'default' },
    idQuestion: { type: String, required: false },
    itemId: { type: String, required: false },
    lang: { type: String, required: false, default: 'br' },
    template: { type: String, required: false, default: 'default' },
    pageBackground: { type: String, required: false, default: '#fff' },
    limitChoices: { type: String, required: false, default: '' },
  },
  data: () => ({
    isSelected: null,
    comment: null,
    otherComment: '',
    applicabled: null,
    review: null,
  }),
  mounted() {
    this.isSelected = this.selected;
  },
  watch: {
    comment: function watchComment() {
      this.update();
    },
    otherComment: function watchOtherComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },
  methods: {
    update() {
      let other = '';
      const otherField = this.choices.filter((item) => item.isOther);
      if(otherField.length){
        other = (otherField[0].text) ? otherField[0].text : '';

        if(this.lang === 'us'){
          other = (otherField[0].textEN) ? otherField[0].textEN : '';
        } else if(this.lang === 'es'){
          other = (otherField[0].textES) ? otherField[0].textES : '';
        }
      }

      let multipleValues;

      if (Array.isArray(this.isSelected)) {
        if (otherField.length && this.isSelected.indexOf(other) !== -1) {
          multipleValues = [...this.isSelected, this.otherComment];

          const newArray = this.isSelected.filter(
            (item) => item !== other,
          );
          multipleValues = [
            ...newArray,
            `${other}: ${this.otherComment}`,
          ];
        } else {
          multipleValues = this.isSelected;
        }
      } else {
        multipleValues =
          otherField.length && other === this.isSelected
            ? `${other}: ${this.otherComment}`
            : this.isSelected;
      }

      const ids = [];

      if (this.type === 'checkbox') {
        for (let i = 0; i < this.choices.length; i += 1) {
          for (let j = 0; j < this.isSelected.length; j += 1) {
            if (
              this.choices[i].text === this.isSelected[j] ||
              this.choices[i].textEN === this.isSelected[j] ||
              this.choices[i].textES === this.isSelected[j]
            ) {
              ids.push(this.choices[i].id);
            }
          }
        }

        if (
          this.limitChoices !== '' &&
          this.limitChoices !== 0 &&
          this.limitChoices !== '0' &&
          this.isSelected.length >= Number(this.limitChoices)
        ) {
          for (let a = 0; a < this.choices.length; a += 1) {
            if (!ids.includes(this.choices[a].id)) {
              this.choices[a].disabled = true;
            } else {
              this.choices[a].disabled = false;
            }
          }
        } else {
          for (let a = 0; a < this.choices.length; a += 1) {
            this.choices[a].disabled = false;
          }
        }
      }

      this.$emit('input', {
        multipleValues,
        comment: this.comment,
        review: this.review,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
// .btn-group-vertical {
//   padding-left: 0;
//   padding-right: 0;
// }
.btn-light:hover {
  background: #f8f9fa;
}
.icon-checked {
  display: none;
}
.icon-checked-big {
  display: none;
}
.custom-checkbox {
  margin-bottom: 8px;
  border-width: 3px;
  text-align: left;
}
@media (max-width: 1500px) {
  label.btn.btn-light.btn-lg.active {
    border-color: #07b2f0;
    border-radius: 5px;
    border-width: 2px;
    .icon-checked {
      display: inline;
    }
    .icon-checked-big {
      display: inline;
    }
  }
}
label.btn.btn-light.btn-lg {
  box-shadow: none;
  border-radius: 5px;
  padding-top: 0;
  padding-bottom: 0;
  border-color: #f8f9fa;
  border-width: 1px;
}
@media (min-width: 1501px) {
  label.btn.btn-light.btn-lg.active {
    border-color: #07b2f0;
    border-radius: 5px;
    border-width: 2px;
    .icon-checked {
      display: inline;
      margin-left: 85%;
    }
    .icon-checked-big {
      display: inline;
    }
  }
}
.multiple-question-area {
  display: flex;
  //display: block;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 0;
  .chips-area {
    display: flex;
    flex-direction: row;
    margin-left: 16px;
    .chip {
      padding: 3px 15px;
      font-size: 16px;
      border-radius: 20px;
      margin: 2px;
      background-color: $gray;
      border: 1px solid $white;
      color: $white;
    }
  }
}
.chip-multiple {
  padding: 3px 15px;
  font-size: 16px;
  border-radius: 20px;
  margin: 2px;
  background-color: $gray;
  border: 1px solid $white;
  color: $white;
  min-width: 45%;
  width: 45%;
}
.break-word {
  word-break: break-word;
}
.comment-area {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/multiple-choices/index.vue